import styled from 'styled-components';

export const PopconfirmStyled = styled.div`
  .ant-popover {
    width: 400px !important;
  }
  .popconfirmBox {
    background: red;
  }
`;
